// Runtime config (production/monolith) takes precedence over build-time env vars (development)
const runtimeConfig =
    typeof window !== "undefined" ? window.ENV_CONFIG : undefined;

export const FRONTEND_HOST =
    runtimeConfig?.VITE_FRONTEND_HOST ?? import.meta.env.VITE_FRONTEND_HOST;

export const API_HOST =
    runtimeConfig?.VITE_API_HOST ?? import.meta.env.VITE_API_HOST;

export const APPLICANT_PROFILE_TYPE_ID = import.meta.env
    .VITE_APPLICANT_PROFILE_TYPE_ID;

// Pattern with `{subdomain}` placeholder used to build the public URL of a
// tenant from its subdomain. Defaults to dev convention.
export const TENANT_URL_PATTERN: string =
    runtimeConfig?.VITE_TENANT_URL_PATTERN ??
    import.meta.env.VITE_TENANT_URL_PATTERN ??
    "http://{subdomain}.localhost:5173";

export function buildTenantUrl(subdomain: string): string {
    return TENANT_URL_PATTERN.replace("{subdomain}", subdomain);
}
